import { render, staticRenderFns } from "./radio.html?vue&type=template&id=d6b6ac72&scoped=true&"
import script from "./radio.js?vue&type=script&lang=js&"
export * from "./radio.js?vue&type=script&lang=js&"
import style0 from "./radio.scss?vue&type=style&index=0&id=d6b6ac72&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b6ac72",
  null
  
)

export default component.exports